import LandingCard from '../components/landing/LandingCard'

export default function HomePage() {
  return <LandingCard />
}
